<template>
  <v-row>
    <v-col>
      <v-subheader class="white--text">Teslimat Bilgileri</v-subheader>
      <v-list dense color="transparent">
        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Adres </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.address }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Tarih </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.deliveryDate | moment("DD MMMM YYYY, dddd") }} | Saat
              {{ callCenterStore.deliveryHour }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Ödeme </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.paymentType }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Şube </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.deliveryCustomer }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Fatura/Fiş Gönderim </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title
              ><v-chip
                :color="!callCenterStore.data.delivery.needinvoice ? 'success' : 'error'"
                label
                small
              >
                {{ !callCenterStore.data.delivery.needinvoice ? "Evet" : "Hayır" }}
              </v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Fatura Adresi Farklı </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title
              ><v-chip
                :color="callCenterStore.data.delivery.isdifferentinvoiceaddr ? 'success' : 'error'"
                small
                label
              >
                {{ callCenterStore.data.delivery.isdifferentinvoiceaddr ? "Evet" : "Hayır" }}
              </v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content class="flex-grow-1">
            <v-list-item-title> Sipariş Notu </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content style="flex-grow: 2 !important">
            <v-list-item-title>
              {{ callCenterStore.deliveryNote }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
// Store
import { useCallCenterStore } from "@/stores/callCenter";

export default {
  setup() {
    const callCenterStore = useCallCenterStore();
    return {
      callCenterStore,
    };
  },
};
</script>

<style></style>
